import { local } from '@/utils/storage'

const STORAGE_KEY = 'appPlatform'
const APP_PLATFORMS = ['ios', 'android']

function platformFromUserAgent () {
  const match = /CoridorApp\/(ios|android)/i.exec(navigator.userAgent || '')
  return match ? match[1].toLowerCase() : null
}

// Native uygulamalar user agent'a "CoridorApp/<platform>" ekliyor. Eski sürümler bunu yapmadığı için
// ilk açılış URL'sindeki ?webview=true&platform=... parametresi de saklanıp yedek olarak kullanılıyor.
export function getAppPlatform () {
  if (typeof window === 'undefined') {
    return null
  }

  const fromUserAgent = platformFromUserAgent()
  if (fromUserAgent) {
    return fromUserAgent
  }

  const params = new URLSearchParams(window.location.search)
  const fromQuery = (params.get('platform') || '').toLowerCase()
  if (params.get('webview') === 'true' && APP_PLATFORMS.includes(fromQuery)) {
    local.set(STORAGE_KEY, fromQuery)
    return fromQuery
  }

  const stored = local.get(STORAGE_KEY)
  return APP_PLATFORMS.includes(stored) ? stored : null
}

export function buildDirectionsUrl (location) {
  if (!location?.latitude || !location?.longitude) {
    return '#'
  }

  const coordinates = `${location.latitude},${location.longitude}`
  const platform = getAppPlatform()

  if (platform === 'ios') {
    return `https://maps.apple.com/?daddr=${coordinates}`
  }

  if (platform === 'android') {
    // geo: niyeti, kullanıcının seçtiği harita uygulamasında konumu işaretli açar.
    const label = location.name ? `(${encodeURIComponent(location.name)})` : ''
    return `geo:0,0?q=${coordinates}${label}`
  }

  return `https://www.google.com/maps/dir/?api=1&destination=${coordinates}`
}
